import { initialState } from "../reducers/organisationDirectoryReducer";

export const emptyLiveFloorViewerSection = (clearFilters = true) => async dispatch => {
	if (clearFilters) dispatch({type: 'FETCH_LIVE_FLOOR_VIEWER_FILTERS', payload: {...initialState}});
}